module.exports = __webpack_public_path__ + "static/media/lingshou-3.347ff05b.png";